"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _buttonModule = _interopRequireDefault(require("./sass/button.module.scss"));

var _excluded = ["className", "children", "color", "disabled", "fullWidth", "fullWidthMobile", "icon", "onClick", "type"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Buttonv2 = function Buttonv2(_ref) {
  var _buttonClasses, _iconClassess;

  var className = _ref.className,
      children = _ref.children,
      color = _ref.color,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      fullWidthMobile = _ref.fullWidthMobile,
      icon = _ref.icon,
      onClick = _ref.onClick,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  var buttonClasses = (_buttonClasses = {}, _defineProperty(_buttonClasses, _buttonModule.default.global, true), _defineProperty(_buttonClasses, _buttonModule.default.primary, color === 'primary'), _defineProperty(_buttonClasses, _buttonModule.default.secondary, color === 'secondary'), _defineProperty(_buttonClasses, _buttonModule.default.ghost, color === 'ghost'), _defineProperty(_buttonClasses, _buttonModule.default.elementbase, color === 'elementbase'), _defineProperty(_buttonClasses, _buttonModule.default.link, color === 'link'), _defineProperty(_buttonClasses, _buttonModule.default.bluelegacy, color === 'bluelegacy' || color === 'primarylegacy'), _defineProperty(_buttonClasses, _buttonModule.default.greenlegacy, color === 'greenlegacy' || color === 'secondarylegacy'), _defineProperty(_buttonClasses, _buttonModule.default.danger, color === 'danger' || color === 'red' || color === 'redlegacy'), _defineProperty(_buttonClasses, _buttonModule.default.disabled, disabled), _defineProperty(_buttonClasses, _buttonModule.default.block_mobile, fullWidthMobile), _defineProperty(_buttonClasses, _buttonModule.default.display_block, fullWidth), _defineProperty(_buttonClasses, className, className), _buttonClasses);
  var iconClassess = (_iconClassess = {
    icon: true
  }, _defineProperty(_iconClassess, "".concat(className, "__icon"), className), _defineProperty(_iconClassess, _buttonModule.default.children_icon, icon), _iconClassess);
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    type: type,
    className: (0, _classnames.default)(buttonClasses),
    disabled: disabled,
    onClick: onClick
  }, props), icon ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(iconClassess)
  }, children) : /*#__PURE__*/_react.default.createElement("span", {
    className: _buttonModule.default.children
  }, children));
};

Buttonv2.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  color: _propTypes.default.oneOf(['primary', 'secondary', 'ghost', 'elementbase', 'link', 'bluelegacy', 'primarylegacy', 'greenlegacy', 'secondarylegacy', 'danger', 'red', 'redlegacy']),
  disabled: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  fullWidthMobile: _propTypes.default.bool,
  icon: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  type: _propTypes.default.oneOf(['submit', 'button'])
};
Buttonv2.defaultProps = {
  className: null,
  children: 'Label',
  color: 'primary',
  disabled: false,
  fullWidth: false,
  fullWidthMobile: false,
  icon: null,
  onClick: function onClick() {},
  type: 'submit'
};
var _default = Buttonv2;
exports.default = _default;